export const GET_LINKS = "GET_LINKS";
export const GET_LINK_BY_ID = "GET_LINK_BY_ID";
export const UPDATE_LINK = "UPDATE_LINK";
export const DELETE_LINK = "DELETE_LINK";
export const CREATE_LINK = "CREATE_LINK";
export const UPLOAD = "CREATE_LIUPLOADNK";
